// ============================================
// ROLC OneROLC - Shared Utilities
// Version: 3.6.0
// ============================================

import { CONFIG, IDLE_TIMEOUT_MS, IDLE_KEY } from './config/constants.js';
import { formatTimestamp, capitalizeWords, formatDateForInput, formatTimeForInput, formatDateKey } from './utils/formatters.js';
import { $, $$, createElement, addClass, removeClass, toggleClass, hasClass, setContent } from './utils/domHelpers.js';
import { getToken, setToken, removeToken, getSessionId, setSessionId, removeSessionId, getName, setName, removeName, getRole, setRole, removeRole, getMasterToken, setMasterToken, removeMasterToken, getIsMasterAdmin, setIsMasterAdmin, removeIsMasterAdmin, getLastActivity, setLastActivity, getCached, setCached, getCachedWithTimestamp, setCachedWithTimestamp, clearAuth } from './utils/storage.js';

function showToast(message, type = "info", duration = 3000) {
    let container = document.getElementById("toast-container");
    if (!container) {
        container = document.createElement("div");
        container.id = "toast-container";
        container.style.cssText = "position:fixed;top:60px;right:16px;z-index:99999;display:flex;flex-direction:column;gap:8px;pointer-events:none;";
        document.body.appendChild(container);
    }
    const colors = { success: { bg: "#d1fae5", text: "#065f46" }, error: { bg: "#fee2e2", text: "#991b1b" }, info: { bg: "#dbeafe", text: "#1e40af" }, warning: { bg: "#fef3c7", text: "#92400e" } };
    const c = colors[type] || colors.info;
    const toast = document.createElement("div");
    toast.style.cssText = "background:" + c.bg + ";color:" + c.text + ";padding:10px 18px;border-radius:8px;font-size:0.9rem;font-weight:600;box-shadow:0 2px 8px rgba(0,0,0,0.15);pointer-events:auto;animation:toastIn 0.25s ease-out;";
    toast.textContent = message;
    container.appendChild(toast);
    toast.addEventListener("click", () => toast.remove());
    setTimeout(() => { toast.style.transition = "opacity 0.3s"; toast.style.opacity = "0"; setTimeout(() => toast.remove(), 300); }, duration);
}

function normalizeLastName(value) {
    if (!value) return "";
    return value.trim().replace(/\s+/g, " ").toLowerCase().replace(/^\w/, c => c.toUpperCase());
}

function escapeHtml(str) {
    if (str == null) return "";
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
}

function stripHtml(str) {
    if (!str) return "";
    let text = String(str);
    text = text.replace(/<br\s*\/?>/gi, "\n");
    text = text.replace(/<\/p>\s*<p[^>]*>/gi, "\n");
    text = text.replace(/<p[^>]*>/gi, "");
    text = text.replace(/<\/p>/gi, "\n");
    text = text.replace(/<div[^>]*>/gi, "");
    text = text.replace(/<\/div>/gi, "\n");
    text = text.replace(/<[^>]+>/g, "");
    text = text.replace(/&amp;/g, "&");
    text = text.replace(/&lt;/g, "<");
    text = text.replace(/&gt;/g, ">");
    text = text.replace(/&quot;/g, '"');
    return text.trim();
}

export { showToast, normalizeLastName, escapeHtml, stripHtml };

const Utils = {
    formatTimestamp, capitalizeWords, formatDateForInput, formatTimeForInput, formatDateKey,
    $, $$, createElement, addClass, removeClass, toggleClass, hasClass, setContent,
    getToken, setToken, removeToken, getSessionId, setSessionId, removeSessionId, getName, setName, removeName, getRole, setRole, removeRole, getMasterToken, setMasterToken, removeMasterToken, getIsMasterAdmin, setIsMasterAdmin, removeIsMasterAdmin, getLastActivity, setLastActivity, getCached, setCached, getCachedWithTimestamp, setCachedWithTimestamp, clearAuth,
    normalizeLastName, escapeHtml, stripHtml, showToast,
    updateLastActivity() { setLastActivity(); },
    checkIdle(timeoutMs) { const last = getLastActivity(); return last && (Date.now() - parseInt(last, 10)) > timeoutMs; },
    isTestEnv() { return CONFIG.VERSION.includes("-TEST"); }
};

window.Utils = Utils;
window.CONFIG = CONFIG;
window.$ = $;
window.$$ = $$;



